module.exports = __webpack_public_path__ + "img/plusAdd.a687ab80.svg";